import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { PreAssessmentComponent } from '../steps/preassessment.component';
import { DialogService } from '../../shared/services/dialog.service';

@Injectable()
export class CanDeactivatePreAssessmentService implements CanDeactivate<PreAssessmentComponent> {

  constructor(private dialogService: DialogService) { }

  canDeactivate(
    component: PreAssessmentComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {

    if (!component.canDeactivate) {

      return this.dialogService.confirm('You have not saved your responses. Are you sure you want to leave?');

    }
    return true;
  }
}
